import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static get targets () {
        return ['head', 'body'];
    }

    headTargetConnected() {
        this.stickHead(this.bodyTarget.offsetHeight);
        window.addEventListener('scroll', () => this.stickHead(this.bodyTarget.offsetHeight));
    }

    stickHead(maxHeight) {
        const rect = this.element.getBoundingClientRect();
        const bodyHeight = maxHeight;
        const navbarHeight = document.querySelector('.site-header').offsetHeight;
        const timetableHeaderHeight = this.element.querySelector('.timetable-header').offsetHeight;
        let top = timetableHeaderHeight + navbarHeight;
        let isStickyMenu = document.body.classList.contains('sticky-menu');

        if (isStickyMenu) {
            top -= navbarHeight;
        }

        if (window.screen.width < 991) {
            top += 150;
        } else {
            top += 45;

            if (isStickyMenu) {
                top += 35;
            }
        }

        if (rect.top < (top * -1)) {
            let fromTop = (rect.top + top) * -1;

            if (fromTop >= bodyHeight) {
                fromTop = bodyHeight;
            }

            this.headTarget.classList.add('sticky');
            this.headTarget.style.top = fromTop + 'px';
        } else {
            this.headTarget.classList.remove('sticky');
        }
    }
}